<template>
  <div class="main-content" autocomplete="off">
    <div>
      <b-row>
        <b-col md="8">
          <h2 class="page-title">
            Quotes
          </h2>
        </b-col>
        <!-- <b-col md="4">
          <b-form-input
            v-model="searchWord"
            class="form-control-rounded"
            type="text"
            required
            placeholder="Search..."
          ></b-form-input>
        </b-col> -->
      </b-row>
      <div v-if="!$apollo.loading && quoteSections && quoteSections.length">
        <b-table
          class="custom-table"
          striped
          th-class="cursor-pointer"
          hover
          bordered
          responsive
          sort-icon-left
          :items="quoteSections"
          :fields="fields"
        >
          <!-- <template v-slot:cell(client)="row">
            <div v-if="row.item.client">
              {{ row.item.client.name }}
            </div>
          </template> -->
          <template v-slot:cell(quote)="row">
            {{ row.item.name }}
          </template>
          <template v-slot:cell(end)="row">
            {{ row.item.end | moment("ll") }}
          </template>
          <template v-slot:cell(status)="row">
            <b-badge :variant="getStatusVariant(row.item.status)">
              {{ row.item.status }}
            </b-badge>
          </template>
          <template v-slot:cell(total)="row">
            <div
              v-if="!row.item.total && row.item.total !== 0"
              class="loader"
            ></div>
            <div v-else>R{{ row.item.total }}</div>
          </template>
          <template v-slot:cell(users)="row">
            <div
              v-for="user in getQuoteUsers(row.item)"
              :key="user.lastName + user.firstName"
            >
              <ProjectAvatar
                :user="user"
                :hide-nick-name="true"
                :width="24"
                :height="24"
                :only-initials="true"
              />
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="actions">
              <router-link
                :to="
                  `/Client/${row.item.clientId}?q=Quote_${row.item.clientId}_${row.item.name}`
                "
              >
                <b-button size="sm" variant="outline-info">
                  View Tasks
                </b-button>
              </router-link>
              <!-- <b-button
                size="sm"
                variant="danger"
                @click="deleteClientTrigger(row.item.name)"
              >
                Delete
              </b-button> -->
            </div>
          </template>
        </b-table>

        <!-- <transition-group name="fade" tag="b-row"> -->
        <!-- <b-col v-for="client in filteredClients" :key="client.id" md="6" lg="4">
          <ClientBlock
            :client="client"
            @editClient="editClientTrigger"
            @deleteClient="deleteClientTrigger"
          />
        </b-col> -->
        <!-- </transition-group> -->
      </div>
    </div>
  </div>
</template>

<script>
import ProjectAvatar from "@/components/projectAvatar"

export default {
  name: "QuotesReport",
  components: { ProjectAvatar },
  apollo: {
    quoteSections: {
      query: require("@/graphql/Section/QuoteSections.gql"),
      fetchPolicy: "no-cache",
      update(data) {
        data.quoteSections.forEach(async section => {
          section.total = await this.getQuoteTotal(section)
        })
        //Refresh table with totals
        this.refreshTable()
        return data.quoteSections
      }
    },
    clients: {
      query: require("@/graphql/Client/GetClients.gql"),
      fetchPolicy: "no-cache"
    }
  },
  data() {
    return {
      status: "",
      searchWord: "",
      clientIds: [],
      debounceTimmer: null
    }
  },
  computed: {
    filteredQuotes() {
      return []
    }
  },
  created() {
    this.fields = [
      {
        key: "Client",
        formatter: (value, key, item) => {
          return (
            this.clients.find(x => x.id == item.clientId)?.name ?? "No Client"
          )
        },
        sortable: true
      },
      { key: "Quote" },
      { key: "total", sortable: true },
      { key: "end", label: "Due Date", sortable: true },
      // { key: "status", sortable: true },
      { key: "users" },
      { key: "Actions" }
    ]
  },
  methods: {
    refreshTable() {
      if (
        this?.quoteSections?.filter(x => x.total || x.total === 0)?.length !==
          this?.quoteSections?.length ||
        !this?.quoteSections?.filter(x => x.total || x.total === 0)?.length
      ) {
        this.$forceUpdate()
        if (this.debounceTimmer) {
          clearTimeout(this.debounceTimmer)
        }
        this.debounceTimmer = setTimeout(() => {
          this.refreshTable()
        }, 300)
      }
    },
    /**
     * Gets unique array of users for section
     * @param section
     * @returns {*[]}
     */
    getQuoteUsers(section) {
      return [].concat
        .apply([], [...section.tasks.map(x => x.users)])
        .filter(
          (thing, index, self) =>
            index === self.findIndex(t => t.id === thing.id)
        )
    },
    /**
     *
     * @param section
     * @returns {Promise<*>}
     */
    async getQuoteTotal(section) {
      const data = await this.$apollo.query({
        query: require("@/graphql/Quote/GetQuote.gql"),
        variables: {
          sectionName: section.name
        }
      })
      return data.data.quote?.total ?? 0
    },
    /**
     *
     * @param status
     * @returns {*|string}
     */
    getStatusVariant(status) {
      const statuses = {
        default: "info",
        Rejected: "danger",
        Accepted: "success",
        Pending: "info"
      }
      return statuses[`${status}`] || statuses["default"]
    }
  }
}
</script>

<style scoped>
.loader {
  border: 2px solid #f3f3f3;
  border-radius: 50%;
  border-top: 2px solid #3498db;
  width: 25px;
  height: 25px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
